import React, { useState } from "react";

import InvoiceFormGenerally from "Components/Invoice/InvoiceFormGenerally";
import InvoiceFormAgreement from "Components/Invoice/InvoiceFormAgreement";
import InvoiceFormSystem from "Components/Invoice/InvoiceFormSystem";
import InvoiceFormTerms from "Components/Invoice/InvoiceFormTerms";

import { Tabs, Tab, Box } from "@mui/material";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      style={{
        display: value === index ? "block" : "none",
        minHeight: "195px",
      }}
      id={`x-tabpanel-${index}`}
      aria-labelledby={`x-tab-${index}`}
      {...other}
    >
      {<Box>{children}</Box>}
    </div>
  );
}
//FORM_MODES = LOCKED/CREATE/ENDCUSTOMER_CREATE.
export default function InvoiceForm({
  formData,
  FORM_MODE,
  handleInputChange,
  clients,
  endcustomers,
  currencyCodes,
  services,
  boolOptions,
  files,
  setIsCredit,
  isCredit,
  onStopInvoice,
}) {
  const [tabIndex, setTabindex] = useState(0);
  const handleTabSwitch = (event, newValue) => {
    setTabindex(newValue);
  };

  return (
    <>
      <Tabs
        value={tabIndex}
        onChange={handleTabSwitch}
        sx={{ marginBottom: "2rem" }}
      >
        <Tab label="Allmänt" />
        <Tab label="Avtal" />
        <Tab label="Villkor" />
        <Tab label="System" />
      </Tabs>
      <TabPanel value={tabIndex} index={0}>
        {formData && (
          <InvoiceFormGenerally
            formData={formData}
            FORM_MODE={FORM_MODE}
            endcustomers={endcustomers}
            currencyCodes={currencyCodes}
            files={files}
            handleInputChange={handleInputChange}
            setIsCredit={setIsCredit}
            isCredit={isCredit}
            onStopInvoice={onStopInvoice}
          />
        )}
      </TabPanel>
      <TabPanel value={tabIndex} index={1}>
        {formData && (
          <InvoiceFormTerms
            formData={formData}
            FORM_MODE={FORM_MODE}
            currencyCodes={currencyCodes}
            boolOptions={boolOptions}
            services={services}
            handleInputChange={handleInputChange}
          />
        )}
      </TabPanel>
      <TabPanel value={tabIndex} index={2}>
        {formData && (
          <InvoiceFormAgreement
            formData={formData}
            FORM_MODE={FORM_MODE}
            currencyCodes={currencyCodes}
            handleInputChange={handleInputChange}
          />
        )}
      </TabPanel>
      <TabPanel value={tabIndex} index={3}>
        {formData && (
          <InvoiceFormSystem
            formData={formData}
            FORM_MODE={FORM_MODE}
            clients={clients}
            endcustomers={endcustomers}
            currencyCodes={currencyCodes}
            handleInputChange={handleInputChange}
          />
        )}
      </TabPanel>
    </>
  );
}
